import { createRouter, createWebHistory } from '@ionic/vue-router';
import { type RouteRecordRaw } from 'vue-router';
import Login from '../views/Login.vue';
import Home from '../views/Home.vue';
import ShowCategory from '../views/ShowCategory.vue';
import ShowTask from '../views/ShowTask.vue';
import Tools from '../views/Tools.vue';
import AntiStress from '../views/tools/AntiStress.vue';
import Pomodoro from '../views/tools/Pomodoro.vue';
import MoodTracker from '../views/tools/MoodTracker.vue';
import GratitudeLog from '../views/tools/GratitudeLog.vue';
import HeadacheTracker from '../views/tools/HeadacheTracker.vue';
import Settings from '../views/Settings.vue';
import * as Sentry from '@sentry/vue';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import Courses from '../views/Courses.vue';
import ShowCourse from '../views/courses/ShowCourse.vue';
import ShowLesson from '../views/courses/ShowLesson.vue';
import Friends from '../views/Friends.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/category/:categoryId',
    name: 'ShowCategory',
    component: ShowCategory,
    meta: { requiresAuth: true },
  },
  {
    path: '/task/:categoryId/:taskId',
    name: 'ShowTask',
    component: ShowTask,
    meta: { requiresAuth: true },
  },
  {
    path: '/tools',
    name: 'Tools',
    component: Tools,
    meta: { requiresAuth: true },
  },
  {
    path: '/tools/stress',
    name: 'Anti-Stress',
    component: AntiStress,
    meta: { requiresAuth: true },
  },
  {
    path: '/tools/pomodoro',
    name: 'Pomodoro',
    component: Pomodoro,
    meta: { requiresAuth: true },
  },
  {
    path: '/tools/mood',
    name: 'Mood Tracker',
    component: MoodTracker,
    meta: { requiresAuth: true },
  },
  {
    path: '/tools/gratitude',
    name: 'Gratitude Log',
    component: GratitudeLog,
    meta: { requiresAuth: true },
  },
  {
    path: '/tools/headache',
    name: 'Headache Tracker',
    component: HeadacheTracker,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: { requiresAuth: true },
  },
  {
    path: '/friends',
    name: 'Friends',
    component: Friends,
    meta: { requiresAuth: true },
  },
  {
    path: '/friends/add/:friendId',
    name: 'AddFriend',
    component: Friends,
    meta: { requiresAuth: true },
  },
  {
    path: '/courses',
    name: 'Courses',
    component: Courses,
    meta: { requiresAuth: true },
  },
  {
    path: '/courses/:courseId',
    name: 'Course',
    component: ShowCourse,
    meta: { requiresAuth: true },
  },
  {
    path: '/courses/:courseId/lesson/:lessonId',
    name: 'Lesson',
    component: ShowLesson,
    meta: { requiresAuth: true, focusMode: true },
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.onError((error, to) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  ) {
    window.location = to.fullPath as any;
  }
});

router.beforeEach(async (to, _, next) => {
  if (to.meta.requiresAuth) {
    try {
      const user = await FirebaseAuthentication.getCurrentUser();
      if (user == null) {
        next('/');
        return;
      } else {
        next();
        return;
      }
    } catch (ex) {
      Sentry.captureException(ex);
      next('/');
      return;
    }
  }

  next();
});

export default router;
